export default __webpack_public_path__ + "static/bg_home_image-f8fad833481a17656c3047d1c71632de.png";